module.exports = __webpack_public_path__ + "img/blockS4-img1.0b67816b.svg";